@app.service 'ActivitiesService', ($http, $q, $state, $timeout, localStorageService, csConfig) ->

  BOOKMARK_CACHE_KEY = 'chefsteps_bookmarks_cache'
  BOOKMARK_CACHE_TTL = 10 * 60 * 1000
  BOOKMARK_BRAND = 'chefsteps'

  getCurrentUserId = ->
    userId = $state.currentUser?.id
    return null unless userId?
    userId.toString()

  clearBookmarkCache = ->
    localStorage.removeItem(BOOKMARK_CACHE_KEY)

  getBookmarkCache = (userId) ->
    return null unless userId?

    try
      cached = localStorage.getItem(BOOKMARK_CACHE_KEY)
      return null unless cached

      parsed = JSON.parse(cached)
      return null unless parsed?.data?
      return null unless parsed?.timestamp?
      return null unless parsed?.userId?.toString() == userId

      isBrandMatched = !parsed?.brandReferrer? || parsed.brandReferrer == BOOKMARK_BRAND || parsed.brandReferrer == 'cs'
      return null unless isBrandMatched

      isExpired = Date.now() - parsed.timestamp > BOOKMARK_CACHE_TTL
      return null if isExpired

      parsed.data
    catch
      clearBookmarkCache()
      null

  setBookmarkCache = (data, userId) ->
    return unless userId?
    return unless _.isArray(data)

    try
      localStorage.setItem(BOOKMARK_CACHE_KEY, JSON.stringify(
        data: data
        timestamp: Date.now()
        userId: userId
        brandReferrer: BOOKMARK_BRAND
      ))
    catch
      clearBookmarkCache()

  @clone = (srcActivityId, title, config) ->
    $http(
      method: 'POST'
      url: "#{csConfig.chefstepsEndpoint}/api/v0/activities/clone"
      data:
        source_activity_id: srcActivityId
        title: title
        config: config
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
    )

  @trackPageView = (activityId) ->
    return unless csConfig.foodThinkersActivityTrackingEnabled
    return unless activityId

    $http(
      method: 'PUT'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/page-views"
      data:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    )

  @addBookmark = (activityId) ->
    return unless activityId

    $http(
      method: 'PUT'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      data:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    ).then((response) ->
      clearBookmarkCache()
      response
    )

  @removeBookmark = (activityId) ->
    return unless activityId

    $http(
      method: 'DELETE'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      params:
        source_id: activityId.toString()
        source_type: 'activity'
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
      transformResponse: (data, headers) ->
        # FoodThinkers API may return plain text instead of JSON
        # Try to parse as JSON, but return raw data if it fails
        try
          return JSON.parse(data) if data
        catch
          return data
        return data
    ).then((response) ->
      clearBookmarkCache()
      response
    )

  @getBookmarks = ->
    userId = getCurrentUserId()
    cachedBookmarks = getBookmarkCache(userId)

    if cachedBookmarks?
      return $q.resolve(
        data: cachedBookmarks
      )

    $http(
      method: 'GET'
      url: "#{csConfig.foodThinkersEndpoint}/weborch/users/bookmarks"
      headers:
        Authorization: "Bearer #{localStorage.getItem('access_token')}"
        Brand: 'cs'
        'cache-control': 'no-cache, no-store, must-revalidate'
    ).then((response) ->
      setBookmarkCache(response?.data, userId)
      response
    )

  this